"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const scale_1 = require("../../utils/scale");
const react_native_1 = require("react-native");
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const CustomText_1 = __importDefault(require("../text/CustomText"));
const helpler_1 = require("../../utils/helpler");
const ModalReportSuccess = (props) => {
    const { visible, onClose, title, textFirst, textSecond, textThirs, textFour, textFive, } = props;
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "none", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { onPress: () => {
                onClose();
            } },
            react_1.default.createElement(react_native_1.View, { style: styles.viewContain },
                react_1.default.createElement(react_native_1.View, { style: styles.viewModal },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.textTitle }, title),
                    react_1.default.createElement(react_native_1.View, { style: {
                            width: '100%',
                            marginTop: (0, scale_1.scale)(16),
                            paddingHorizontal: (0, scale_1.scale)(16)
                        } },
                        react_1.default.createElement(CustomText_1.default, { style: [styles.textTitle1] }, textFirst),
                        react_1.default.createElement(CustomText_1.default, { style: [styles.textTitle1] }, textSecond),
                        react_1.default.createElement(CustomText_1.default, { style: [styles.textTitle1] }, textThirs),
                        react_1.default.createElement(CustomText_1.default, { style: [
                                styles.textTitle1,
                                {
                                    marginBottom: (0, scale_1.scale)(10),
                                },
                            ] }, textFour),
                        react_1.default.createElement(CustomText_1.default, { style: [styles.textTitle1] }, textFive)),
                    react_1.default.createElement(react_native_1.View, { style: {
                            width: '100%',
                            height: (0, scale_1.scale)(50),
                            marginTop: (0, scale_1.scale)(10),
                            borderTopColor: "#DDDDDD",
                            borderTopWidth: 1,
                        } },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                                flex: 1,
                                alignItems: "center",
                                justifyContent: "center",
                            }, onPress: onClose },
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    fontSize: (0, scale_1.moderateScale)(16),
                                    fontWeight: "300",
                                    lineHeight: (0, scale_1.moderateScale)(24),
                                    color: "#007AFF",
                                } }, "\u9589\u3058\u308B"))))))));
};
const styles = react_native_1.StyleSheet.create({
    btn: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    vBtn: {
        height: (0, scale_1.scale)(62),
        width: "100%",
        borderTopWidth: 1,
        borderTopColor: "#CCCCCC",
        flexDirection: "row",
    },
    textTitle: {
        color: "#292A33",
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
    },
    textTitle1: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: "#292A33",
    },
    viewModal: {
        backgroundColor: "#FFFFFF",
        alignItems: "center",
        borderRadius: (0, scale_1.scale)(12),
        paddingTop: (0, scale_1.scale)(20),
        width: (0, scale_1.scale)(343),
    },
    viewContain: {
        flex: 1,
        backgroundColor: "rgba(0,0,0,0.7)",
        alignItems: "center",
        justifyContent: "center",
    },
    line: {
        width: "100%",
        height: 1,
        backgroundColor: "#F0F3F4",
        marginTop: (0, scale_1.scale)(20),
    },
    input: {
        width: "100%",
        height: (0, scale_1.scale)(42),
        borderWidth: 1,
        borderColor: "#A5A5A5",
        marginTop: (0, scale_1.scale)(10),
        paddingHorizontal: (0, scale_1.scale)(40),
    },
    button: {
        marginVertical: (0, scale_1.scale)(20),
        height: (0, scale_1.scale)(52),
        marginHorizontal: (0, scale_1.scale)(40),
        borderRadius: (0, scale_1.scale)(10),
        width: (0, lodash_1.min)([400, react_native_1.Dimensions.get("window").width * 0.7]),
    },
    err: {
        color: "#FF0000",
        fontSize: (0, scale_1.moderateScale)(13),
        marginBottom: (0, scale_1.scale)(10),
    },
});
exports.default = ModalReportSuccess;
